import * as faCommentCheck from '@fortawesome/pro-regular-svg-icons/faCommentCheck';
export const CommentCheck = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="${faCommentCheck.svgPathData}"/>
  </svg>
`;
